export const FIRST_PHONE_NUMBER = '+998909262832';
export const SECOND_PHONE_NUMBER = '+998909853888';
export const COMPANY_EMAIL = 'distribution@resursi.uz';
export const COMPANY_TELEGRAM_LINK = 'https://t.me/+998909853888';
export const COMPANY_FACEBOOK_LINK = 'https://www.facebook.com/resursi.distribution';
export const COMPANY_INSTAGRAM_LINK = 'https://www.instagram.com/resursi.distribution';
